import AdFormService from "../../services/AdFormService";
import PageData from "../../PageData";
import {SectionId} from "../../services/Section";
import ContactModal from "../../components/modals/ContactModal";
import {EventBus} from "../../events/EventBus";
import {ModalOpenedEvent, WhitelabelEvent} from "../../events/Events";
import UserExits from "../../components/UserExits";
import {getAdIdFromElement} from "./SerpUtils";
import {MultiEnquiryWhatsapp} from "./MultiEnquiryWhatsapp";

export default class SerpContact {
    private readonly pageData: PageData;

    private readonly eventBus: EventBus = EventBus.getInstance();

    constructor(pageData: PageData) {
        this.pageData = pageData;
        new MultiEnquiryWhatsapp(pageData);
    }

    public init = () => {
        this.manageUnitsSlider();
        if (document.getElementsByClassName('js-snippet-contact').length > 0) {
            ContactModal.setup(this.pageData, {allowMultipleSubmit: true});
            this.eventBus.subscribeWithId(ModalOpenedEvent.TYPE, {
                id: 'lamudi-serp-contact-modal-opened-handler',
                callback: (event: WhitelabelEvent) => {
                    const modalOpenedEvent = event as ModalOpenedEvent;
                    const element = modalOpenedEvent.payload.element;
                    const listingId = getAdIdFromElement(element);
                    const container = document.querySelector('#contact-modal-form .js-on-success .js-multi-enquiry-container');
                    if (!listingId || !container) return;
                    new AdFormService().retrieveMultiEnquirySimilars({
                        id: listingId,
                        sectionId: SectionId.SECTION_SEARCH_AD_CONTACT_FORM
                    })
                        .then((multiEnquirySimilarsHtml) => {
                            container.innerHTML = multiEnquirySimilarsHtml;
                            UserExits.init(this.pageData);
                        });
                }
            });
        }
    }

    private manageUnitsSlider() {
        const leftArrows = document.querySelectorAll(".units__button-left");
        const rightArrows = document.querySelectorAll(".units__button-right");

        leftArrows.forEach(arrow => {
            this.moveUnitsSlider(arrow, -229);
        });

        rightArrows.forEach(arrow => {
            this.moveUnitsSlider(arrow, 229);
        });
    }

    private moveUnitsSlider(arrow: Element, amountToMove: number) {
        arrow.addEventListener('click', function (event) {
            event.preventDefault()
            event.stopImmediatePropagation()
            let currentUnits = arrow.closest(".snippet__content__units-container")
                ?.getElementsByClassName("units")
                ?.item(0)
            if (currentUnits && "scrollLeft" in currentUnits) {
                currentUnits.scrollBy({left: amountToMove, top: 0, behavior: 'smooth'});
            }
        });
    }
}